"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_LOGIN = exports.LOGIN = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const auth_1 = require("common/auth");
const Alert_1 = __importDefault(require("react-bootstrap/Alert"));
const __1 = require("..");
const components_1 = require("utils/components");
const AuthUI_1 = require("./AuthUI");
const index_1 = require("../../index");
exports.LOGIN = __1.ADMIN.sub("/login", Login);
exports.GOOGLE_LOGIN = __1.ADMIN.sub("/login/:provider", Login);
const allowedProviders = ["google"];
function Login() {
    const { user, isAdmin, isNotAdmin, error: authError, } = (0, auth_1.useAdminAuthentication)();
    const params = (0, react_router_dom_1.useParams)();
    const authUpdating = (0, auth_1.useAuthSyncState)();
    // Check if the provider is allowed
    if (params.provider && !allowedProviders.includes(params.provider)) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: (0, index_1.resolveRoute)("LOGIN"), replace: true });
    }
    if (isAdmin) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: (0, index_1.resolveRoute)("LIST_PROJECTS"), replace: true });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "consumer-container stacked-form" },
            react_1.default.createElement(AuthUI_1.AuthUI, { provider: params === null || params === void 0 ? void 0 : params.provider }),
            react_1.default.createElement("section", { className: "main-section adjust-width" },
                authUpdating && react_1.default.createElement(components_1.Loading, null),
                isNotAdmin && !authUpdating && (react_1.default.createElement(Alert_1.default, { variant: "danger" },
                    "\u30ED\u30B0\u30A4\u30F3\u4E2D\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9(", user === null || user === void 0 ? void 0 :
                    user.email,
                    ") \u306B\u306F\u7BA1\u7406\u8005\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u5225\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3067\u30ED\u30B0\u30A4\u30F3\u3057\u306A\u304A\u3059\u304B\u3001\u7BA1\u7406\u8005\u307E\u3067\u9023\u7D61\u3057\u3066\u304F\u3060\u3055\u3044"))),
            react_1.default.createElement("section", { className: "main-section" }))));
}
exports.default = Login;
